<button *ngIf="isEditMode" class="btn btn-primary" type="button" (click)="openAddQuestion(addQuestion);">Add Question</button>

<ng-template #addQuestion let-modal>
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">Add Question To Question Bank</h4>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <form [formGroup]="addQuestionBankQuestionForm">
        <div class="modal-body">
            <error-message [errors]="errors"></error-message>

            <div class="row form-group">
                <div class="col">
                    <label class="col-form-label">Questions</label>
                    <select class="js-example-basic-single form-select" name="questionId" formControlName="questionId" placeholder="Select an existing question">
                        <option *ngFor="let question of questions" [value]="question.id">{{ question.title | htmlToText }}</option>
                    </select>
                    <span class="text-muted">Use key words or phrases to see if a question already exists, or create a new question.</span>
                </div>
            </div>

            <div class="row form-group my-3">
                <div class="col">
                    <label class="col-form-label me-3">Or</label>
                    <button class="btn btn-primary btn-block" type="button" (click)="modal.close('Close');" [routerLink]="['/question/add', questionBankId]">Add New Question</button>
                </div>
            </div>

            <div class="row form-group">
                <div class="col-md-6">
                    <div class="form-group">
                        <label class="col-form-label">Audit Type</label>
                        <select name="auditTypeId" class="form-select" formControlName="auditTypeId">
                            <option *ngFor="let auditType of auditTypes" [value]="auditType.id">{{ auditType.name}}</option>
                        </select>
                    </div>
                </div>
                <div class="col-md-6">
                    <label class="control-label">
                        Is Mandatory
                    </label>
                    <input type="checkbox" id="isMandatory" name="isMandatory" class="form-control" formControlName="isMandatory" appToggle />
                    <input name="order" type="hidden" formControlName="zOrder" />
                </div>
            </div>
        </div>

        <div class="modal-footer">
            <div class="row">
                <div class="col-md-12 text-right">
                    <button type="button" class="btn btn-outline-primary modal-dismiss ms-2" (click)="modal.close('Close');">Cancel</button>
                    <button type="button" class="btn btn-success modal-dismiss ms-2" (click)="addQuestionToQuestionBank();" [disabled]="submitAttempt||!addQuestionBankQuestionForm.valid">Ok</button>
                </div>
            </div>
        </div>
    </form>
</ng-template>
